import {
  type GetCasesRequestQuery,
  type GetCasesResponse,
  getCasesResponse,
} from "@clipboard-health/contract-worker-app-bff";
import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";

const GET_BOOKED_CASES_URL = `${environmentConfig.REACT_APP_WORKER_APP_BFF_URL}/in-home/cases`;
export const getBookedCasesQueryKey = [GET_BOOKED_CASES_URL];

export function useGetCases(
  params: GetCasesRequestQuery,
  options: UseGetQueryOptions<GetCasesResponse> = {}
) {
  return useGetQuery({
    url: GET_BOOKED_CASES_URL,
    queryParams: params,
    responseSchema: getCasesResponse,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_BOOKED_CASES_FAILURE,
    },
    retry: 0,
    staleTime: 1000 * 60 * 1,
    ...options,
  });
}
